var e={container:"FullScreenGallery-module_container__56Yy7"};export{e as default};
//# sourceMappingURL=FullScreenGallery.module.scss.js.map
